import { clearStructureCache } from "hooks/useStructureQueries";

async function clearLocalStorage() {
  localStorage.removeItem("ApiCredentials");
  localStorage.removeItem("localStorage");
  localStorage.removeItem("sessoesMenuUser");
  localStorage.removeItem("k-user");
  localStorage.removeItem("k-user-vision");
  localStorage.removeItem("userVision");
  localStorage.removeItem("sessoesMenuUserVision");
  localStorage.removeItem("viewsMenuUserVision");
  localStorage.removeItem("userDetailVision");
  localStorage.removeItem("userProfilesVision");
  localStorage.removeItem("loggedIn");
  localStorage.removeItem("usuarioSubCategorias");
  localStorage.removeItem("usuarioMarcas");
  localStorage.removeItem("viewsMenuUser");
  localStorage.removeItem("usuarioLojas");
  localStorage.removeItem("dateLastRequest");
  localStorage.removeItem("userDetail");
  localStorage.removeItem("usuarioCategorias");
  localStorage.removeItem("estruturaComercial");
  localStorage.removeItem("isMobile");
  localStorage.removeItem("visao360StoreList");
  localStorage.removeItem("visao360EconomicGroupList");
  localStorage.removeItem("Marca=KarstenDecor");
  localStorage.removeItem("Marca=Karsten");
  localStorage.removeItem("Marca=Trussardi");
  localStorage.removeItem("invoiceStatus360");

  clearStructureCache();
}

const Storage = {
  clear() {
    return clearLocalStorage();
  },
};

export default Storage;
